import classNames from 'classnames';
import arrayMutators from 'final-form-arrays';
import { bool, node } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Field, Form as FinalForm } from 'react-final-form';
import { compose } from 'redux';

import {
  FieldCheckbox,
  FieldPhoneInput,
  FieldTextInput,
  Form,
  PrimaryButton,
	ValidationError
} from '../../../components';
import { FormattedMessage, injectIntl, intlShape } from '../../../util/reactIntl';
import * as validators from '../../../util/validators';

import { AutoComplete } from 'antd';
import { getPropsForCustomUserFieldInputs, getRandomPassword } from '../../../util/userHelpers';
import SectionPartA from '../../PageBuilder/SectionBuilder/SectionPartA/SectionPartA';
import { loadCities } from '../AuthenticationPage.duck';
import css from './SignupEsianForm.module.css';
import Step1 from './img/step1.png';
import Step2 from './img/step2.png';
import Step3 from './img/step3.png';
import defaultConfig from '../../../config/configDefault';
import TeamAbstract from './TeamAbstract';

const SignupFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={fieldRenderProps => {
      const {
        rootClassName,
        className,
        formId,
        handleSubmit,
        inProgress,
        invalid,
        intl,
        termsAndConditions,
        userFields,
        userType,
        updateUserType,
        signupCheck,
        updateSignupCheck,
				onLoadCities,
        form,
      } = fieldRenderProps;
			
      // email
      const emailRequired = validators.required(
        intl.formatMessage({
          id: 'SignupForm.emailRequired',
        })
      );
      const emailValid = validators.emailFormatValid(
        intl.formatMessage({
          id: 'SignupForm.emailInvalid',
        })
      );

      // password
      const passwordRequiredMessage = intl.formatMessage({
        id: 'SignupForm.passwordRequired',
      });
      const passwordMinLengthMessage = intl.formatMessage(
        {
          id: 'SignupForm.passwordTooShort',
        },
        {
          minLength: validators.PASSWORD_MIN_LENGTH,
        }
      );
      const passwordMaxLengthMessage = intl.formatMessage(
        {
          id: 'SignupForm.passwordTooLong',
        },
        {
          maxLength: validators.PASSWORD_MAX_LENGTH,
        }
      );
      // Custom user fields. Since user types are not supported here,
      // only fields with no user type id limitation are selected.
      const userFieldProps = getPropsForCustomUserFieldInputs(userFields, intl);

      const classes = classNames(rootClassName || css.root, className);
      const submitInProgress = inProgress;
      const submitDisabled = invalid || submitInProgress || !signupCheck;

      const firstNameStudent = intl.formatMessage({
        id: 'SignupForm.firstNameStudentLabel',
      });
      const lastNameStudent = intl.formatMessage({
        id: 'SignupForm.lastNameStudentLabel',
      });

      const firstNameOrganization = intl.formatMessage({
        id: 'SignupForm.firstNameOrganizationLabel',
      });
      const lastNameOrganization = intl.formatMessage({
        id: 'SignupForm.lastNameOrganizationLabel',
      });

      const firstNameUniversity = intl.formatMessage({
        id: 'SignupForm.firstNameUniversityLabel',
      });
      const lastNameUniversity = intl.formatMessage({
        id: 'SignupForm.lastNameUniversityLabel',
      });

      const signupCheckEsian = intl.formatMessage({
        id: 'SignupForm.signupCheckEsianLabel',
      });

      const signupCheckStudent = intl.formatMessage({
        id: 'SignupForm.signupCheckStudentLabel',
      });
			const [options, setOptions] = useState([]);
      useEffect(() => {
        form.change('password', getRandomPassword());
      }, []);

      return (
        <div>
          <div className={css.topDiv}>
            <span>
              <FormattedMessage id="SignupEsianForm.heading" />
            </span>{' '}
            
           
          </div>
          <div className={css.esianOuterDiv}>
            <div>
              <div className={css.leftDiv}>
                <div className={css.stepDiv}>
                  <img src={Step1} />
                  <h4>
                    <FormattedMessage id="SignupEsianForm.registrationHeading" />
                  </h4>
                  <span>
                    <FormattedMessage id="SignupEsianForm.registrationDescription" />
                  </span>
                </div>

                <div className={css.stepDiv}>
                  <img src={Step2} />
                  <h4>
                    <FormattedMessage id="SignupEsianForm.profileHeading" />
                  </h4>
                  <span>
                    <FormattedMessage id="SignupEsianForm.profileDescription" />
                  </span>
                </div>

                <div className={css.stepDiv}>
                  <img src={Step3} />
                  <h4>
                    <FormattedMessage id="SignupEsianForm.validationHeading" />
                  </h4>
                  <span>
                    <FormattedMessage id="SignupEsianForm.validationDescription" />
                  </span>
                </div>
              </div>
            </div>
            <div className={css.rightDiv}>
              <span className={css.topForm}>
                <FormattedMessage id="SignupEsianForm.title" />
              </span>
              <Form className={classes} onSubmit={handleSubmit} style={{height:'auto'}}>
                {userType && userType != 'esian' ? (
                  <>
                    <div>
                      <div className={css.name}>
                        <FieldTextInput
                          className={css.firstNameRoot}
                          type="text"
                          id={formId ? `${formId}.fname` : 'fname'}
                          name="fname"
                          autoComplete="given-name"
                          label={
                            userType == 'organizationEsian'
                              ? firstNameOrganization
                              : userType == 'university'
                              ? firstNameUniversity
                              : firstNameStudent
                          }
                          placeholder={intl.formatMessage({
                            id: 'SignupForm.firstNamePlaceholder',
                          })}
                          validate={validators.required(
                            intl.formatMessage({
                              id: 'SignupForm.firstNameRequired',
                            })
                          )}
													required={true}
                        />
                        <FieldTextInput
                          className={css.lastNameRoot}
                          type="text"
                          id={formId ? `${formId}.lname` : 'lname'}
                          name="lname"
                          autoComplete="family-name"
                          label={
                            userType == 'organizationEsian'
                              ? lastNameOrganization
                              : userType == 'university'
                              ? lastNameUniversity
                              : lastNameStudent
                          }
                          placeholder={intl.formatMessage({
                            id: 'SignupForm.lastNamePlaceholder',
                          })}
                          validate={validators.required(
                            intl.formatMessage({
                              id: 'SignupForm.lastNameRequired',
                            })
                          )}
													required={true}
                        />
                      </div>
                      <br />
                      {userType == 'organizationEsian' ? (
                        <>
                          <FieldTextInput
                            type="text"
                            id={formId ? `${formId}.organizationName` : 'organizationName'}
                            name="organizationName"
                            label={intl.formatMessage({
                              id: 'SignupForm.organizationNameLabel',
                            })}
                            placeholder={intl.formatMessage({
                              id: 'SignupForm.organizationNamePlaceholder',
                            })}
                            validate={validators.required(
                              intl.formatMessage({
                                id: 'SignupForm.organizationNameRequired',
                              })
                            )}
														required={true}
                          />{' '}
                          <br />
                          <FieldTextInput
                            type="text"
                            id={formId ? `${formId}.organizationAddress` : 'organizationAddress'}
                            name="organizationAddress"
                            label={intl.formatMessage({
                              id: 'SignupForm.organizationAddressLabel',
                            })}
                            placeholder={intl.formatMessage({
                              id: 'SignupForm.organizationAddressPlaceholder',
                            })}
                            validate={validators.required(
                              intl.formatMessage({
                                id: 'SignupForm.organizationAddressRequired',
                              })
                            )}
														required={true}
                          />{' '}
                          <br />
                        </>
                      ) : null}
                      {userType == 'university' ? (
                        <>
                          <FieldTextInput
                            type="text"
                            id={formId ? `${formId}.universityName` : 'universityName'}
                            name="universityName"
                            label={intl.formatMessage({
                              id: 'SignupForm.universityNameLabel',
                            })}
                            placeholder={intl.formatMessage({
                              id: 'SignupForm.universityNamePlaceholder',
                            })}
                            validate={validators.required(
                              intl.formatMessage({
                                id: 'SignupForm.universityNameRequired',
                              })
                            )}
														required={true}
                          />{' '}
                          <br />
                          <FieldTextInput
                            type="text"
                            id={formId ? `${formId}.universityAddress` : 'universityAddress'}
                            name="universityAddress"
                            label={intl.formatMessage({
                              id: 'SignupForm.universityAddressLabel',
                            })}
                            placeholder={intl.formatMessage({
                              id: 'SignupForm.universityAddressPlaceholder',
                            })}
                            validate={validators.required(
                              intl.formatMessage({
                                id: 'SignupForm.universityAddressRequired',
                              })
                            )}
														required={true}
                          />{' '}
                          <br />
                        </>
                      ) : null}
                      <div className={classNames(css.sectionContainer)}>
                        <div className={css.profilePhoneNumberSection}>
                          <FieldPhoneInput
                            className={css.phone}
                            name="phoneNumber"
                            id={formId ? `${formId}.phoneNumber` : 'phoneNumber'}
                            label={intl.formatMessage({ id: 'ProfileSettingsForm.phoneNumber' })}
                            placeholder={intl.formatMessage({
                              id: 'ProfileSettingsForm.phoneNumberPlaceHolder',
                            })}
                            defaultCountry="FR"
														countries={defaultConfig.smsAllowedCountryCodes}
                            validate={validators.composeValidators(
                              validators.validatePhoneNumber(
                                intl.formatMessage({
                                  id: 'ProfileSettingsForm.phoneNumberValidMessage',
                                })
                              ),
															validators.required(intl.formatMessage({ id: 'ProfileSettingsForm.phoneNumberRequired'}))
                            )}
														required={true}
                          />
                        </div>
                      </div>{' '}
                      <br />
                      <FieldTextInput
                        type="email"
                        id={formId ? `${formId}.email` : 'email'}
                        name="email"
                        autoComplete="email"
                        label={intl.formatMessage({
                          id: 'SignupForm.emailLabel',
                        })}
                        placeholder={intl.formatMessage({
                          id: 'SignupForm.emailPlaceholder',
                        })}
                        validate={validators.composeValidators(emailRequired, emailValid)}
												required={true}
                      />
                      <FieldTextInput
                        className={css.password}
                        type="text"
                        id={formId ? `${formId}.password` : 'password'}
                        name="password"
                        autoComplete="new-password"
                        label={intl.formatMessage({
                          id: 'SignupForm.passwordLabel',
                        })}
                        placeholder={intl.formatMessage({
                          id: 'SignupForm.passwordPlaceholder',
                        })}
                      />
                      <br />
											<Field
												id="city"
												name="city"
												label={intl.formatMessage({ id: 'ShippingDetails.cityLabel'})}
												placeholder={intl.formatMessage({ id: 'ShippingDetails.cityLabel'})}
												form={null}
												validate={validators.required(intl.formatMessage({ id: 'ProfileSettingsForm.phoneNumberRequired'}))}
												required={true}
											>
												{fieldProps => {
													
													const { id, label, placeholder, meta } = fieldProps;
													const { valid, invalid, touched, error } = meta;
													
													const hasError = !!(touched && invalid && error);
													const fieldMeta = { touched: hasError, error: error };
													const onSelect = e => {
														form.change('city', e);
														form.blur('city');
													};

													const onSearch = (text) => {
														loadCities(text)
															.then((cityOptions) => {
																setOptions(cityOptions);
															})
															.catch(() => setOptions([]));
													};

													return (
														<div className={css.city}>
															<label htmlFor={id}>{label}{fieldProps?.required && <sup>*</sup>}</label>
															<AutoComplete
																{...fieldProps.input}
																className={css.city}
																options={options}
																style={{ width: 200 }}
																onSelect={onSelect}
																onSearch={(text) => onSearch(text)}
																placeholder={placeholder}
															/>
															<ValidationError fieldMeta={fieldMeta} />
														</div>
													);
												}}
											</Field>
											<br />
                      <FieldCheckbox
                        name="signupCheck"
                        id="signupCheck"
                        label={userType == 'student' ? signupCheckStudent : signupCheckEsian}
                        // validate={validators.requiredFieldArrayCheckbox(
                        //   intl.formatMessage({ id: 'AuthenticationPage.termsAndConditionsAcceptRequired' })
                        // )}
                        onChange={e => {
                          updateSignupCheck(e.currentTarget.checked);
                        }}
                      />
                    </div>
                  </>
                ) : null}

                <div className={css.bottomWrapper} style={{marginTop:'-22px !important'}}>
                  {termsAndConditions}
                  <PrimaryButton
                    type="submit"
                    inProgress={submitInProgress}
                    disabled={submitDisabled}
                  >
                    <FormattedMessage id="SignupForm.signUp" />
                  </PrimaryButton>
                </div>
              </Form>
            </div>
          </div>
          <div className={css.infoDiv}>
            {' '}
            <br /> <br />
            <span className={css.topForm}>
              <FormattedMessage id="SignupEsianForm.subHeading1" />
            </span>{' '}
            <br /> <br />
            <span className={css.topForm}>
              <FormattedMessage id="SignupEsianForm.subHeading2" />
            </span>
            <div className={css.infoBoxesDiv}>
              <div className={css.infoBox}>
                <span className={css.infoNumber}> 1</span>
                <span className={css.infoText}>
                  <FormattedMessage id="SignupForm.infoText1" />
                </span>
              </div>

              <div className={css.infoBox}>
                <span className={css.infoNumber}> 2</span>
                <span className={css.infoText}>
                  <FormattedMessage id="SignupForm.infoText2" />
                </span>
              </div>

              <div className={css.infoBox}>
                <span className={css.infoNumber}> 3</span>
                <span className={css.infoText}>
                  <FormattedMessage id="SignupForm.infoText3" />
                </span>
              </div>
            </div>
          </div>{' '}
          <br />
          <div className={css.textContentDiv}>
            <span className={css.textContent}>
              <FormattedMessage id="SignupForm.textContentHeading" />
            </span>
          </div>
          <SectionPartA isEsianForm={true} />
					<TeamAbstract  isEasian = {true}/>
          <div className={css.textContentDiv}>
            <span className={css.textContent}>
              <FormattedMessage id="SignupForm.videoContenHeading" />
            </span>{' '}
            <br /> <br />
            {/* <iframe className="mfp-iframe" src="https://world-like-home.com/videos/TeaserST_WIH_VF.mp4" allowfullscreen="yes" allow="autoplay" height={500} width={800} frameBorder={0} ></iframe> */}
            <iframe
             className={css.iframeBecomeaHost}
              src="https://www.youtube.com/embed/iFoy1LFFlCE?autoplay=1&amp;mute=1"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      );
    }}
  />
);

SignupFormComponent.defaultProps = { inProgress: false };

SignupFormComponent.propTypes = {
  inProgress: bool,
  termsAndConditions: node.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const SignupForm = compose(injectIntl)(SignupFormComponent);
SignupForm.displayName = 'SignupForm';

export default SignupForm;
